/**
 * Get Swatch Image
 *
 * Dormify has a lot of weird color values
 *   Some have extra dashes and / and spaces
 * This function will format all of these and return the correct url
 *
 * @param {String} value - swatch string value
 * @return {URL} URL of given swatch Value
 */
export var getSwatchImage = function getSwatchImage(value) {
  var formattedValue = value.replace(/ /g, '-') // replace all spaces for -
  .replace('---', '-').replace('--', '-').replace('-/-', '---').replace('/', '-').toLowerCase();
  var imageUrl = 'https://cdn.shopify.com/s/files/1/1765/3959/files/' + formattedValue + '-40x40.png';
  return imageUrl;
};

/**
 * Get Color Hex
 *
 * @param {String} color - Swatch color
 * @return {String} Hex value of swatch color
 */
export var getColorHex = function getColorHex(color) {
  var ColorObj = {
    amethyst: '#B695C6',
    'antique white': '#fbf5e8',
    aqua: '#c0dddf',
    'ashley blue': '#b4c9d3',
    baltic: '#43acb3',
    beige: '#ede6d6',
    black: '#000000',
    'black silver': '#000000',
    blonde: '#EBCEB3',
    blue: '#5b7d9e',
    blush: '#ffd0dd',
    bone: '#DAD1B0',
    'bright white': '#FFFFFF',
    brown: '#462103',
    brunette: '#553C3A',
    'burnt orange': '#e67734',
    celedon: '#c2d9d7',
    chambray: '#5b7d9e',
    charcoal: '#5f5f5f',
    chocolate: '#462103',
    citron: '#f6f872',
    clear: '#FFFFFF',
    coral: '#e96a64',
    'coral spice': '#e96a64',
    crimson: '#9C2236',
    'crushed gravel': '#767676',
    'dark grey': '#818181',
    'dark purple': '#543491',
    'default title': '#FFFFFF',
    denim: '#294782',
    'dusty blue': '#98bbdf',
    'dusty rose': '#F7CAC9',
    dusty_rose: '#FED4D0',
    eggplant: '#78668c',
    egret: '#f0e7d9',
    emberglow: '#e96a64',
    'faux jute': '#ede6d6',
    fog: '#d7d7d7',
    'forest green': '#00431b',
    'frost grey': '#7c7c7c',
    green: '#067059',
    grey: '#6c6c6c',
    harbor: '#badede',
    'heather grey': '#B5B1B2',
    'hot pink': '#ff0096',
    indigo: '#2c288b',
    ivory: '#fdfced',
    labradorite: '#698F89',
    'light blue': '#d1e4f2',
    'light grey': '#C5C6C5',
    'light pinirvanank': '#EBD5D5',
    'light pink': '#ffd0dd',
    'light purple': '#BFB1C6',
    light_blue: '#d1e4f2',
    lilac: '#6276B8',
    lime: '#a3e044',
    linen: '#c7ae99',
    magenta: '#E9659E',
    'matte black': '#000000',
    'matte charcoal': '#818181',
    'matte light pink': '#F9CFD3',
    mauve: '#b99baf',
    'metallic grey': '#66625F',
    mimosa: '#f7d61f',
    mint: '#c2d9d7',
    naked: '#f7e2b8',
    natural: '#ede6d6',
    navy: '#06236c',
    'neon pink': '#ff0096',
    nirvana: '#bbacc7',
    olive: '#60726C',
    orange: '#e67734',
    'palm print': '#691FF6',
    'peacoat navy': '#06236c',
    'pebble grey': '#bcbcbc',
    periwinkle: '#A7B8DF',
    pewter: '#6c6c6c',
    pink: '#ffd0dd',
    'pink flamingo': '#E62C82',
    powder: '#F0D6C8',
    pumpkin: '#e67734',
    purple: '#bbacc7',
    'purple pink': '#D967DA',
    quartz: '#FFFFFF',
    red: '#e71111',
    'rose quartz': '#E5BEC0',
    'rose smoke': '#e8d3d0',
    sage: '#badede',
    seapunk: '#00ACAD',
    'seashell white': '#474847',
    'shiny white': '#FFFFFF',
    smoke: '#474847',
    'smoke blue': '#5f5f5f',
    'spiced coral': '#E55663',
    tan: '#B59D7F',
    taupe: '#d6bda0',
    teal: '#43acb3',
    turquoise: '#43acb3',
    violet: '#854eae',
    white: '#FFFFFF',
    wine: '#732323',
    yellow: '#f7d61f'
  };
  return ColorObj[color];
};